/**
 * Single canonical re-export of prop-types so Parcel and all deps (react-router,
 * MUI, etc.) use the same instance. Fixes "propTypes.oneOf is not a function"
 * when multiple copies or stubs are resolved.
 */
module.exports = require('./node_modules/prop-types/index.js');
